var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.fondo)?_c('HyFFondo'):_vm._e(),(!_vm.hideHeader)?_c('Header'):_vm._e(),_c('div',{staticClass:"main-content row mx-0"},[_c('div',{staticClass:"col-12 px-0"},[_vm._t("default")],2)]),(!_vm.hideFooter)?_c('FooterNuevo'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }